import React from 'react'
import '../../styles/mdx.scss'

export default function FlexGallery2 ({ children }) {
  return (
    <div className="mdx">
        <div className="mdx__flexgallery2">
            { children }
        </div>
    </div>
  )
}
